<template style="height:100%">
  <div class="Labor_statistics">
    <el-form style="padding: 14px;background: #fff;" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="工作小组">
        <el-select v-model="formInline.dropKeyID" placeholder="请选择小组">
          <el-option v-for="item in options" :key="item.dropKeyID" :value="item.dropKeyID"
            :label="item.dropKeyContent">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker v-model="formInline.time" value-format="yyyy-MM" type="month" placeholder="选择月"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>

    <div style="height: 16px;width: 100%;background: rgb(235, 236, 237);"></div>

    <div class="nav">
      <el-table :data="tableData" style="width: 100%">

        <el-table-column prop="dropKeyContent" label="小组名称" ></el-table-column>
        <el-table-column prop="salaryDate" label="统计月份" ></el-table-column>
        <el-table-column prop="workDay1_6" label="1_6号工作小时" ></el-table-column>
        <el-table-column prop="workDay7_13" label="7_13号工作小时" ></el-table-column>
        <el-table-column prop="workDay14_20" label="14_20号工作小时" ></el-table-column>
        <el-table-column prop="workDay21_27" label="21_27号工作小时" ></el-table-column>
        <el-table-column prop="workDay28_" label="28号后工作小时" ></el-table-column>
        <el-table-column prop="workingHours" label="当月总工作小时" ></el-table-column>
        <el-table-column prop="salary" label="当月总报酬" ></el-table-column>
      </el-table>

      <el-pagination @current-change="handleCurrentChange"
          :current-page.sync="formInline.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
        </el-pagination>
    </div>




  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData:[],
      Counts:0,
      options: [],
      formInline: {
        dropKeyID: '',
        time: '',
        pageIndex: 1,
        pageSize: 10,
      }
    };
  },
  components:{

  },
  methods: {
    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.load(val);
    },
    onSubmit(){
      this.formInline.pageIndex = 1;
      this.load();
    },
    reset(){
      this.formInline.dropKeyID = '';
      this.formInline.time = '';
      this.formInline.pageIndex = 1;
      this.load();
    },
    load(){
      var k = this.formInline.time.split("-");
      var Vintage = k[0];
      var Month = k[1];
      this.$Http_Post("/workingtime/getsalarystatisticlist", {
        dropKeyID:this.formInline.dropKeyID,
        pageIndex:this.formInline.pageIndex,
        pageSize:this.formInline.pageSize,
        year:Vintage,
        month:Month,
      }).then((res) => {
        this.loadings = false;
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
        }
      })
    }
  },

  created() {

  },

  mounted() {
    this.load();
    this.$Http_Post('/workingtime/getdropdownkeylist', { dropKeyType: "WorkGroup", "pageIndex": 1, "pageSize": 10 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.options = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  }
};
</script>
<style>
.Labor_statistics{width: 100%;height: 100%;background-color: #fff;}
.Labor_statistics .nav{height: calc(100% - 120px);}
</style>